import types from './types';
import signInService from 'src/services/signin/SignInService';
import tokenService from 'src/services/token/TokenService';
import userService from 'src/services/user/userService';
import { default as userActions } from 'src/store/modules/user/actions';
import env from 'src/shared/env';

const signin = (username: string, password: string): any => {
  return (dispatch: any) => {
    dispatch(signinPending(true));

    signInService
      .sigIn(username, password)
      .then(signInResponse => {
        tokenService.setToken(signInResponse).then((response: any) => {
          const userDataWithToken = userService.castTokenToClass(
            tokenService.decodeToken(signInResponse.accessToken)
          );
          dispatch(setSamsungUserSignIn(signInResponse.isSamsungUser || false));
          dispatch(setSelectAccount(signInResponse.shouldSelectAccount));
          dispatch(setShouldVerify(signInResponse.isFirstLogin));
          dispatch(
            setShouldUpdateInfo(
              signInResponse.isApdepotUser && signInResponse.isFirstLogin
            )
          );
          dispatch(userActions.userData(userDataWithToken));
          dispatch(userActions.getUserDetails());
          dispatch(
            setActiveAccount(
              userDataWithToken.accountId ? userDataWithToken.accountId : ''
            )
          );
          dispatch(setActiveAccountCountry(env.REACT_APP_BASE_ENVIRONMENT));
          dispatch(activeAccountHasChanged(true));
          dispatch(signinSuccessful(true));
          dispatch(signinPending(false));
        });
      })
      .catch(e => {
        console.error(e);
        dispatch(signinPending(false));
        dispatch(signinFailed(e));
      });
  };
};

const setSamsungUserSignIn = (samsungUserSignIn: boolean) => {
  return { type: types.SET_SAMSUNG_USER_SIGN_IN, payload: samsungUserSignIn };
};

const setShouldVerify = (shouldVerify: boolean) => {
  return { type: types.SET_SHOULD_VERIFY, payload: shouldVerify };
};

const setShouldUpdateInfo = (shouldUpdateInfo: boolean) => {
  return { type: types.SET_SHOULD_UPDATE_INFO, payload: shouldUpdateInfo };
};

const signinPending = (isPending: boolean) => {
  return { type: types.SIGNIN_PENDING, payload: isPending };
};

const signinSuccessful = (result: boolean) => {
  return { type: types.SIGNIN_SUCCESS, payload: result };
};

const doSignOut = () => {
  return { type: types.SIGNOUT };
};

const changeActiveAccount = (accountId: string, clientIdentity: string) => {
  if (accountId == null) {
    accountId = '';
  }
  if (accountId.length === 0) {
    return (dispatch: any) => {
      dispatch(setActiveAccount(accountId));
      dispatch(setActiveAccountCountry(env.REACT_APP_BASE_ENVIRONMENT));
    };
  }
  return (dispatch: any) => {
    dispatch(signinPending(true));
    dispatch(activeAccountHasChanged(false));
    signInService
      .switchAccount(accountId, clientIdentity)
      .then(switchAccountResponse => {
        tokenService.setToken(switchAccountResponse).then((resolved: any) => {
          const userDataWithToken = userService.castTokenToClass(
            tokenService.decodeToken(switchAccountResponse.accessToken)
          );

          dispatch(
            setSamsungUserSignIn(switchAccountResponse.isSamsungUser || false)
          );
          dispatch(setSelectAccount(switchAccountResponse.shouldSelectAccount));
          dispatch(setShouldVerify(switchAccountResponse.isFirstLogin));
          dispatch(
            setShouldUpdateInfo(
              switchAccountResponse.isApdepotUser &&
                switchAccountResponse.isFirstLogin
            )
          );
          dispatch(userActions.userData(userDataWithToken));
          dispatch(setActiveAccount(accountId));
          dispatch(setActiveAccountCountry(env.REACT_APP_BASE_ENVIRONMENT));
          dispatch(activeAccountHasChanged(true));
          dispatch(signinSuccessful(true));
          dispatch(signinPending(false));
        });
      })
      .catch(error => {
        dispatch(signinPending(false));
        dispatch(activeAccountHasChanged(false));
        dispatch(signinFailed(error));
      });
  };
};

const activeAccountHasChanged = (hasChanged: boolean) => {
  return { type: types.ACTIVE_ACCOUNT_HAS_CHANGED, payload: hasChanged };
};

const setActiveAccountCountry = (activeAccountCountry: string) => {
  return {
    type: types.SET_ACTIVE_ACCOUNT_COUNTRY,
    payload: activeAccountCountry
  };
};

const setActiveAccount = (activeAccount: string) => {
  return { type: types.CHANGE_ACTIVE_ACCOUNT, payload: activeAccount };
};

const setSelectAccount = (shouldSelectAccount: boolean) => {
  return { type: types.SET_SELECT_ACCOUNT, payload: shouldSelectAccount };
};

const signinFailed = (error: any) => {
  return {
    type: types.SIGNIN_ERROR,
    payload: {
      hasFailed: true,
      message: error.message
    }
  };
};

const signout = (): any => {
  return (dispatch: any) => {
    tokenService.logOut();
    dispatch(doSignOut());
    dispatch(changeActiveAccount('', ''));
    dispatch(userActions.removeUserData());
  };
};

export default {
  signin,
  signout,
  signinPending,
  signinSuccessful,
  signinFailed,
  changeActiveAccount,
  activeAccountHasChanged,
  setSelectAccount,
  setShouldVerify,
  setShouldUpdateInfo,
  setActiveAccount,
  setActiveAccountCountry
};
